import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the bonus report view.
 * @extends JetView
 */
export default class tableBonusReportView extends JetView {
    /**
     * Configures the datatable for the bonus report.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user ID from parameters

        return {
            view: 'datatable', // Datatable view
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            columns: [
                // Column definitions
                {
                    id: 'detailTittle',
                    header: '',
                    width: 50,
                    height: 25,
                    tooltip: 'Detalles', // Tooltip for details icon
                    template: function (obj) {
                        // Template for details icon
                        return "<span class='webix_icon wxi-close details'></span>";
                    },
                },
                { id: 'Id', header: 'Id', width: 60, sort: 'int' }, // ID column
                {
                    id: 'ClientId',
                    header: 'ID Cliente',
                    width: 60,
                    sort: 'int',
                },
                {
                    id: 'PartnerBonusId',
                    header: 'Id Bono',
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'PartnerBonusName',
                    header: 'Nombre de Bono',
                    width: 500,
                    sort: 'int',
                },
                {
                    id: 'AcceptanceDateLocal',
                    header: 'Fecha Aceptación',
                    width: 150,
                    sort: 'int',
                },
                { id: 'BonusType', header: 'Tipo', width: 100, sort: 'int' }, // Bonus type column
                { id: 'State', header: 'Estado', width: 100, sort: 'int' }, // State column
                {
                    id: 'Amount',
                    header: 'Valor',
                    format: webix.i18n.priceFormat, // Formatting for price
                    exportType: 'number',
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'CreatedLocal',
                    header: 'Fecha Modificacion',
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'AmountConverted',
                    header: 'Monto Convertido',
                    format: webix.i18n.priceFormat,
                    exportType: 'number',
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'RolloverRequired',
                    header: 'Rollover Requerido',
                    format: webix.i18n.priceFormat,
                    exportType: 'number',
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'RolloverWagered',
                    header: 'Apostado',
                    format: webix.i18n.priceFormat,
                    exportType: 'number',
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'RolloverRemaining',
                    header: 'Restante',
                    format: webix.i18n.priceFormat,
                    exportType: 'number',
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'ClientBonusExpirationDateLocal',
                    header: 'Fecha Expiración',
                    width: 150,
                    sort: 'int',
                },
            ],
            onClick: {
                // Event handler for clicking details icon
                details: function (euv, id) {
                    var item = this.getItem(id); // Get the clicked item
                    this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                },
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable math operations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID
            // API URL for fetching data
            url: devConfig.geturlApi() + 'es/Report/GetClientBonusReport?PlayerId=' + cur_user + '',
        };
    }

    /**
     * Initializes the grid and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Current user ID
        var url = grid.data.url; // Data URL for the grid

        this.on(this.app, 'bonusReport:filter', (filterData) => {
            // Event listener for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters

            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - ');
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Start date filter
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'MinCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to query
                                } else if (object2[j][0] === 'end') {
                                    // End date filter
                                    var d = new Date(object2[j][1]);
                                    var dateTo =
                                        'MaxCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateTo; // Append end date to query
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&PlayerId=' + cur_user; // Append current user ID to query
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
        });

        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event for item click
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        this.on(this.app, 'player:select', (id) => {
            // Event listener for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
